import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App';
import { msalInstance } from './auth';
import '@one/ui/styles.css';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const msal = msalInstance;

if (msal) {
  // Nach dem Abmelden kann „Zurück“ die alte Seite samt Inhalten aus dem Back-Forward-Cache
  // zeigen — am geteilten Rechner sähe die nächste Person dann fremde Daten. Ist kein Konto
  // mehr angemeldet, die Seite deshalb frisch laden (landet auf der Anmeldeseite).
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && msal.getAllAccounts().length === 0) {
      window.location.reload();
    }
  });
  root.render(<p style={{ padding: 32, fontFamily: 'system-ui' }}>ONE startet …</p>);
  msal
    .initialize()
    .then(() => {
      root.render(
        <React.StrictMode>
          <MsalProvider instance={msal}>
            <App />
          </MsalProvider>
        </React.StrictMode>,
      );
    })
    .catch((fehler: unknown) => {
      // Ohne diesen Zweig bliebe die Seite bei einem Fehler in der
      // Entra-Konfiguration einfach weiß — ohne jeden Hinweis.
      console.error('MSAL konnte nicht initialisiert werden', fehler);
      root.render(
        <div style={{ padding: 32, fontFamily: 'system-ui', maxWidth: '40rem' }}>
          <h1 style={{ fontSize: 20 }}>ONE kann die Anmeldung nicht vorbereiten.</h1>
          <p>{fehler instanceof Error ? fehler.message : String(fehler)}</p>
        </div>,
      );
    });
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
